import { render, staticRenderFns } from "./FormControl.vue?vue&type=template&id=b6864106&scoped=true&"
import script from "./FormControl.vue?vue&type=script&lang=ts&"
export * from "./FormControl.vue?vue&type=script&lang=ts&"
import style0 from "./FormControl.vue?vue&type=style&index=0&id=b6864106&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6864106",
  null
  
)

export default component.exports